import React from 'react';
import T from 'prop-types';

const StaticSection = ({ variant, height }) => (
  <div
    className={`static-section static-section--${variant}`}
    style={height ? { height } : undefined}
  />
);

StaticSection.propTypes = {
  variant: T.string.isRequired,
  height: T.number,
};

export default StaticSection;
